var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.167 1H2.833c-.486 0-.952.185-1.296.515C1.193 1.845 1 2.293 1 2.76v18.48c0 .467.193.914.537 1.245.344.33.81.515 1.296.515h18.334c.486 0 .952-.185 1.296-.515.344-.33.537-.778.537-1.245V2.76c0-.467-.193-.914-.537-1.245A1.873 1.873 0 0 0 21.167 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.517 4.85H6.683c-1.012 0-1.833.82-1.833 1.833v1.834c0 1.012.82 1.833 1.833 1.833h1.834c1.012 0 1.833-.82 1.833-1.833V6.683c0-1.012-.82-1.833-1.833-1.833zM8.517 13.65H6.683c-1.012 0-1.833.82-1.833 1.833v1.834c0 1.012.82 1.833 1.833 1.833h1.834c1.012 0 1.833-.82 1.833-1.833v-1.834c0-1.012-.82-1.833-1.833-1.833zM17.317 4.85h-1.834c-1.012 0-1.833.82-1.833 1.833v1.834c0 1.012.82 1.833 1.833 1.833h1.834c1.012 0 1.833-.82 1.833-1.833V6.683c0-1.012-.82-1.833-1.833-1.833zM17.317 13.65h-1.834c-1.012 0-1.833.82-1.833 1.833v1.834c0 1.012.82 1.833 1.833 1.833h1.834c1.012 0 1.833-.82 1.833-1.833v-1.834c0-1.012-.82-1.833-1.833-1.833z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0H24V24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.8caed009.svg";
export { ForwardRef as ReactComponent };